module.exports = __webpack_public_path__ + "img/express.6bd27747.png";